import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Truck } from "lucide-react";
import { DataTable } from "../../components/data/DataTable";
import { NeuButton } from "../../components/neu/Neu";
import { listIncoming, orderDetail } from "../../api/warehouse";
import { WarehouseReceiveForm } from "./WarehouseReceiveForm";
import { localName } from "../../lib/localName";

// تبويب بضاعة واردة: POs موقّعة من المورّد تنتظر الاستلام.
export const WhIncomingTab = ({ branchId }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [detail, setDetail] = useState(null);

  const load = () => listIncoming(branchId || undefined).then((d) => setRows(d.items || []))
    .catch(() => setRows([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [branchId]);

  const columns = [
    { key: "number", label: t("warehouse.orderNo"),
      render: (r) => <span className="num font-mono text-xs font-bold text-primary">{r.number}</span> },
    { key: "supplier", label: t("warehouse.supplier"),
      render: (r) => <span className="text-xs">{localName(r.supplier)}</span> },
    { key: "progress", label: t("warehouse.progress"),
      render: (r) => <span className="num font-mono text-[11px]">
        {r.warehouse_summary?.received_qty}/{r.warehouse_summary?.total_qty}
        ({r.warehouse_summary?.progress_percent}%)</span> },
    { key: "state", label: t("warehouse.state"),
      render: (r) => <span className={`text-[11px] font-bold ${
        r.state === "partially_received" ? "text-amber-600" : "text-emerald-600"}`}>
        {t(`warehouse.states.${r.state}`)}</span> },
    { key: "act", label: "",
      render: (r) => <NeuButton className="px-3 py-2 text-[11px]" data-testid={`wh-open-${r.id}`}
                                 onClick={() => orderDetail(r.id).then(setDetail)}>
        <Truck className="inline h-3.5 w-3.5" /> {t("warehouse.receive")}</NeuButton> },
  ];

  return detail ? (
    <WarehouseReceiveForm detail={detail} onClose={() => setDetail(null)}
                          onDone={() => { setDetail(null); load(); }} />
  ) : (
    <DataTable testid="wh-incoming" columns={columns} rows={rows} rowKey={(r) => r.id}
               empty={t("warehouse.empty")} />
  );
};
